module.exports = __webpack_public_path__ + "109745197994b1070cdb48c1a0510a68.svg";